import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { CreateStoreStockRecallErrorItem } from '../../model/create-store-stock-recall.model';
import { errorCreateStoreStockRecallResponse } from './create-stock-recall.action';

export interface CreateStoreStockRecallState extends EntityState<any> {
  items: CreateStoreStockRecallErrorItem[];
}
export const adapter: EntityAdapter<any> = createEntityAdapter<any>();

export const initialCreateStoreStockRecallState: CreateStoreStockRecallState = adapter.getInitialState({
  items: null
});

export const createStoreStockRecallReducer = createReducer(
  initialCreateStoreStockRecallState,
  on(errorCreateStoreStockRecallResponse, (state, action): CreateStoreStockRecallState => {
    return {
      ...state,
      items: action.items
    };
  })
);
